module.exports = __webpack_public_path__ + "images/unit-icons/10x20-parking_space.svg";